import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsPhoneConfigurationRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-phone-configuration',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/phone',
	exact: true,
};
